/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import {
  Avatar,
  Col,
  Collapse,
  Divider,
  Input,
  List,
  message,
  Popconfirm,
  Row,
  Tabs,
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { getInvoicesByStatus } from "../../../lib/getInvoicesByStatus";
import { updateInvoiceStatus } from "../../../lib/updateInvoiceStatus";
import ModalComprobantePago from "../invoices/ModalComprobantePago";
import ModalManageEmployee from "./ModalManageEmployee";
import ModalPreviewPDF from "./ModalPreviewPDF";


const CompanyView = () => {
  const [listOfInvoices, setListOfInvoices] = useState([]);
  const [showModalManage, setShowModalManage] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState();
  const [cancelReason, setCancelReason] = useState("");
  const [showPreviewPDF, setShowPreviewPDF] = useState(false);
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';
  const [showUploadModal, setShowUploadModal] = useState(false);
  const serverHost = `http://${window.location.hostname.includes('localhost') ? 'localhost:4000' : 'unioninformatica.org:4000'}`;

  useEffect(() => {
    getInvoicesByStatus("PENDING").then((res) => {
      setListOfInvoices(res.data);
    });
  }, []);

  const notifyCanceled = (companyName) => {
    toast.warning(
      `✔️ Factura cancelada, se enviara un email a ${companyName} explicando el motivo.`,
      {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
      }
    );
  };
const parseData = (data) => {
  return JSON.stringify(data)
}
  const CustomExpandIcon = ({ isActive }) => {
    return !isActive ? <EyeOutlined /> : <EyeInvisibleOutlined />;
  };

  const [position, setPosition] = useState("bottom");
  const [align, setAlign] = useState("center");

  function countInvoicesByStatus(item, status) {
    let count = 0;
    for (let i = 0; i < item.invoices.length; i++) {
      if (item.invoices[i].status === status) {
        count++;
      }
    }
    return count;
  }

  const calcularTotal = (data) => {
    const algo = Object.values(data).reduce(
      (accumulator, employee) =>
        accumulator +
        employee.reduce(
          (empAccumulator, emp) => empAccumulator + emp.calculatedSalary,
          0
        ),
      0
    );

    return Number(algo).toLocaleString("de-DE", { maximumFractionDigits: 2 });
  };

  return (
    <>
      <ToastContainer />
      <h2>Panel de facturación</h2>
      <List
        style={{ marginTop: "50px" }}
        pagination={{
          position,
          align,
        }}
        dataSource={listOfInvoices}
        renderItem={(item, index) => (
          <List.Item>
            <div style={{ width: "100%" }}>
              <List.Item.Meta
                avatar={
                  <Avatar
                    shape="square"
                    src={
                      item.company.image
                        ? item.company.image
                        : "https://icon-library.com/images/default-profile-icon/default-profile-icon-24.jpg"
                    }
                    size={"large"}
                  />
                }
                title={<h4>{item.company.name}</h4>}
                description={
                  <>
                    <div className="d-flex flex-wrap pt-4">
                      <div className="d-flex align-items-center pe-4 mb-2">
                        <div className="pe-2">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 4.5H4C3.20435 4.5 2.44129 4.81607 1.87868 5.37868C1.31607 5.94129 1 6.70435 1 7.5V17.5C1 18.2956 1.31607 19.0587 1.87868 19.6213C2.44129 20.1839 3.20435 20.5 4 20.5H20C20.7956 20.5 21.5587 20.1839 22.1213 19.6213C22.6839 19.0587 23 18.2956 23 17.5V7.5C23 6.70435 22.6839 5.94129 22.1213 5.37868C21.5587 4.81607 20.7956 4.5 20 4.5ZM21 17.25L16.1 12.85L21 9.42V17.25ZM3 9.42L7.9 12.85L3 17.25V9.42ZM9.58 14.03L11.43 15.32C11.5974 15.4361 11.7963 15.4984 12 15.4984C12.2037 15.4984 12.4026 15.4361 12.57 15.32L14.42 14.03L19.42 18.5H4.6L9.58 14.03ZM4 6.5H20C20.1857 6.50149 20.3673 6.55467 20.5245 6.65358C20.6817 6.75249 20.8083 6.89322 20.89 7.06L12 13.28L3.11 7.06C3.19171 6.89322 3.31826 6.75249 3.47545 6.65358C3.63265 6.55467 3.81428 6.50149 4 6.5Z"
                              fill="#F79F19"
                            />
                          </svg>
                        </div>
                        <h5 className="font-w400 mb-0">{item.company.email}</h5>
                      </div>
                      <div className="d-flex align-items-center pe-4 mb-2">
                        <div className="pe-2">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.4401 13.5004C19.2201 13.5004 18.9901 13.4304 18.7701 13.3804C18.3246 13.2822 17.8868 13.1518 17.4601 12.9904C16.9962 12.8216 16.4862 12.8304 16.0284 13.015C15.5706 13.1996 15.1972 13.547 14.9801 13.9904L14.7601 14.4404C13.7861 13.8985 12.8911 13.2256 12.1001 12.4404C11.3149 11.6494 10.6419 10.7544 10.1001 9.78036L10.5201 9.50036C10.9635 9.28327 11.3109 8.90989 11.4955 8.45205C11.6801 7.99421 11.6889 7.48427 11.5201 7.02036C11.3613 6.59278 11.231 6.15515 11.1301 5.71036C11.0801 5.49036 11.0401 5.26036 11.0101 5.03036C10.8887 4.32598 10.5197 3.6881 9.96972 3.2316C9.41972 2.77509 8.7248 2.52997 8.0101 2.54036H5.0101C4.57913 2.53631 4.15235 2.62517 3.75881 2.80089C3.36527 2.9766 3.01421 3.23505 2.72953 3.55864C2.44485 3.88222 2.23324 4.26335 2.10909 4.67607C1.98494 5.08879 1.95118 5.52342 2.0101 5.95036C2.54284 10.1397 4.45613 14.0322 7.44775 17.013C10.4394 19.9938 14.3388 21.8929 18.5301 22.4104H18.9101C19.6475 22.4114 20.3595 22.1409 20.9101 21.6504C21.2265 21.3674 21.4792 21.0205 21.6516 20.6327C21.8239 20.2448 21.9121 19.8248 21.9101 19.4004V16.4004C21.8979 15.7057 21.6449 15.0369 21.1944 14.508C20.744 13.9791 20.1239 13.623 19.4401 13.5004ZM19.9401 19.5004C19.9399 19.6423 19.9095 19.7827 19.8509 19.912C19.7923 20.0413 19.7068 20.1566 19.6001 20.2504C19.4884 20.3468 19.3577 20.4189 19.2165 20.462C19.0753 20.505 18.9267 20.5181 18.7801 20.5004C15.035 20.0202 11.5563 18.3068 8.89282 15.6306C6.2293 12.9545 4.53251 9.46769 4.0701 5.72036C4.05419 5.57387 4.06813 5.42569 4.1111 5.28475C4.15407 5.14381 4.22517 5.01304 4.3201 4.90036C4.41381 4.79369 4.52916 4.7082 4.65848 4.64957C4.7878 4.59095 4.92812 4.56054 5.0701 4.56036H8.0701C8.30265 4.55518 8.52972 4.63124 8.71224 4.77543C8.89476 4.91962 9.02131 5.12293 9.0701 5.35036C9.1101 5.62369 9.1601 5.89369 9.2201 6.16036C9.33562 6.6875 9.48936 7.20554 9.6801 7.71036L8.2801 8.36036C8.1604 8.41528 8.05272 8.4933 7.96326 8.58995C7.87379 8.6866 7.8043 8.79997 7.75877 8.92355C7.71324 9.04713 7.69257 9.17849 7.69795 9.31008C7.70332 9.44167 7.73464 9.5709 7.7901 9.69036C9.2293 12.7731 11.7073 15.2512 14.7901 16.6904C15.0336 16.7904 15.3066 16.7904 15.5501 16.6904C15.6748 16.6458 15.7894 16.5768 15.8873 16.4875C15.9851 16.3983 16.0643 16.2905 16.1201 16.1704L16.7401 14.7704C17.2571 14.9552 17.7847 15.1088 18.3201 15.2304C18.5868 15.2904 18.8568 15.3404 19.1301 15.3804C19.3575 15.4291 19.5608 15.5557 19.705 15.7382C19.8492 15.9207 19.9253 16.1478 19.9201 16.3804L19.9401 19.5004Z"
                              fill="#FF5B5B"
                            />
                          </svg>
                        </div>
                        <h5 className="font-w400 mb-0">
                          {item.company.phoneNumber}
                        </h5>
                      </div>
                      <div className="d-flex align-items-center pe-4 mb-2">
                        <div className="pe-2">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 1024 1024"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM472 744a40 40 0 1080 0 40 40 0 10-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z"
                              fill="#008000"
                            />
                          </svg>
                        </div>
                        <h5 className="font-w400 mb-0">{item.count}</h5>
                      </div>
                    </div>
                  </>
                }
              />
              <Collapse
                style={{ width: "100%", border: "none" }}
                ghost={true}
                expandIcon={CustomExpandIcon}
              >
                <Collapse.Panel
                  style={{
                    width: "100%",
                    backgroundColor: "rgb(224 224 224 / 25%)",
                  }}
                  header="Ver facturas"
                >
                  <Tabs defaultActiveKey="1">
                    <Tabs.TabPane
                      tab={`PENDIENTES (${countInvoicesByStatus(
                        item,
                        "PENDING"
                      )})`}
                      key="1"
                    >
                      {item.invoices.map((invoice, index) => {
                        if (invoice.status === "PENDING") {
                          return (
                            <>
                              <Row
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                                  <p style={{ fontWeight: "bold" }} key={index}>
                                    Factura Nº: {invoice.invoiceNumber}
                                  </p>
                                  <p  style={{ fontWeight: "500" }}>
                                  <b>Tipo Factura:</b> {(invoice?.tipoFactura && invoice?.tipoFactura ==="formacion") ? 'Por Formacion': 'Sindical'} 

                                  </p>
                                  <p>
                                    <strong>Período : </strong>
                                    
                                    {moment(invoice.period[0]).format(
                                      "DD/MM/YYYY"
                                    )}{" "}
                                    -{" "}
                                    {moment(invoice.period[1]).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </p>
                                </Col>
                                <Col
                                  xs={20}
                                  sm={16}
                                  md={12}
                                  lg={8}
                                  xl={8}
                                ></Col>

                                <Link
                                  to={"#"}
                                  onClick={() => {
                                    setSelectedInvoice(invoice);
                                    setShowModalManage(true);
                                    setSelectedCompany(invoice.company._id);
                                  }}
                                  className="btn btn-primary shadow btn-xs sharp me-3"
                                >
                                  <i className="fas fa-check"></i>
                                </Link>
                                <Popconfirm
                                  placement="left"
                                  title={"Atención"}
                                  description={
                                    <span
                                      style={{
                                        paddingRight: "20px",
                                      }}
                                    >
                                      <h5>
                                        ¿Desea <strong>cancelar</strong> esta
                                        factura?
                                      </h5>
                                      <p>Ingrese el motivo de la cancelación</p>
                                      <Input
                                        placeholder="Motivo"
                                        onChange={(e) =>
                                          setCancelReason(e.target.value)
                                        }
                                      />
                                    </span>
                                  }
                                  onConfirm={async () => {
                                    if (cancelReason.length > 0) {
                                      const { _id } = invoice;

                                      const metaData = {
                                        emailTo: item.company.email,
                                        companyName: item.company.name,
                                        invoiceNumber: invoice.invoiceNumber,
                                      };

                                      await updateInvoiceStatus(
                                        _id,
                                        {
                                          status: "CANCELED",
                                          motive: cancelReason,
                                        },
                                        metaData,
                                        {}
                                      ).then((res) => {
                                        if (res.data === "OK") {
                                          setCancelReason("");
                                          notifyCanceled(item.company.name);
                                          getInvoicesByStatus("PENDING").then(
                                            (res) => {
                                              setListOfInvoices(res.data);
                                            }
                                          );
                                        }
                                      });
                                    } else {
                                      message.error(
                                        "Debe ingrese un motivo de cancelación"
                                      );
                                    }
                                  }}
                                  okText="Si"
                                  cancelText="No"
                                  onCancel={() => {
                                    setCancelReason("");
                                  }}
                                >
                                  <Link
                                    to={"#"}
                                    onClick={() => {}}
                                    className="btn btn-danger shadow btn-xs sharp me-3"
                                  >
                                    <i className="fas fa-times"></i>
                                  </Link>
                                </Popconfirm>
                              </Row>
                              <Divider style={{ backgroundColor: "#e6e6e6" }} />
                            </>
                          );
                        }
                      })}
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={`ACEPTADAS (${countInvoicesByStatus(
                        item,
                        "ACCEPTED"
                      )})`}
                      key="2"
                    >
                      {item.invoices.map((invoice, index) => {
                        if (invoice.status === "ACCEPTED") {
                          return (
                            <>
                              <Row
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                                  <p style={{ fontWeight: "bold" }} key={index}>
                                    Factura Nº: {invoice.invoiceNumber}
                                  </p>
                                  <p  style={{ fontWeight: "500" }}>
                                  <b>Tipo Factura:</b> {(invoice?.tipoFactura && invoice?.tipoFactura ==="formacion") ? 'Por Formacion': 'Sindical'} 

                                  </p>
                                  <p>
                                    <strong>Período : </strong>
                                    {moment(invoice.period[0]).format(
                                      "DD/MM/YYYY"
                                    )}{" "}
                                    -{" "}
                                    {moment(invoice.period[1]).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </p>
                                  <p>
                                    <strong>
                                      Importe total : ${" "}
                                      {calcularTotal(invoice.detail)}
                                    </strong>
                                  </p>
                                </Col>
                                <Col
                                  xs={20}
                                  sm={16}
                                  md={12}
                                  lg={8}
                                  xl={8}
                                ></Col>

                                <Link
                                  to={"#"}
                                  onClick={() => {
                                    setSelectedInvoice(invoice);
                                    setShowPreviewPDF(true);
                                  }}
                                  className="btn btn-warning shadow btn-xs sharp me-3"
                                >
                                  <i className="fas fa-eye"></i>
                                </Link>
                                <Link
                                  to={"http://"+url+":4000/api/v1/boletaDigital/csvExportData?invoceId="+invoice._id} 
                                  target="_blank"
                                  className="btn btn-warning shadow btn-xs sharp me-3"
                                >
                                  EX
                                </Link>
                                {!invoice.comprobantePath ? (
                        <Link
                          to={"#"}
                          onClick={() => {
                            setSelectedInvoice(invoice);
                            setShowUploadModal(true);
                          }}
                          title="Cargar Comprobante"
                          className="btn btn-warning shadow btn-xs sharp me-3"
                        >
                          <i className="fas fa-file"></i>
                        </Link>
                      ) : (
                        <Link
                          to={`${serverHost}${invoice.comprobantePath}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-success shadow btn-xs sharp me-3"
                          title="Ver comprobante"
                        >
                          <i className="fas fa-paperclip"></i>
                        </Link>
                      )}
                              </Row>
                              <Divider style={{ backgroundColor: "#e6e6e6" }} />
                            </>
                          );
                        }
                      })}
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={`CANCELADAS (${countInvoicesByStatus(
                        item,
                        "CANCELED"
                      )})`}
                      key="3"
                    >
                      {item.invoices.map((invoice, index) => {
                        if (invoice.status === "CANCELED") {
                          return (
                            <>
                              <Row
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                                  <p style={{ fontWeight: "bold" }} key={index}>
                                    Factura Nº: {invoice.invoiceNumber}
                                  </p>
                                  <p  style={{ fontWeight: "500" }}>
                                  <b>Tipo Factura:</b> {(invoice?.tipoFactura && invoice?.tipoFactura ==="formacion") ? 'Por Formacion': 'Sindical'} 

                                  </p>
                                  <p>
                                    <strong>Período : </strong>
                                    {moment(invoice.period[0]).format(
                                      "DD/MM/YYYY"
                                    )}{" "}
                                    -{" "}
                                    {moment(invoice.period[1]).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </p>
                                </Col>
                                <Col xs={20} sm={16} md={12} lg={8} xl={8}>
                                  <strong>Motivo:</strong> {invoice.motive}
                                </Col>
                              </Row>
                              <Divider style={{ backgroundColor: "#e6e6e6" }} />
                            </>
                          );
                        }
                      })}
                    </Tabs.TabPane>
                  </Tabs>
                </Collapse.Panel>
              </Collapse>
            </div>
          </List.Item>
        )}
      />
      <ModalManageEmployee
        show={showModalManage}
        setShow={setShowModalManage}
        selectedCompany={selectedCompany}
        selectedEmployees={selectedEmployees}
        setSelectedEmployees={setSelectedEmployees}
        selectedInvoice={selectedInvoice}
        setListOfInvoices={setListOfInvoices}
        
      />
      {showPreviewPDF && (
        <ModalPreviewPDF
          showOpen={showPreviewPDF}
          setShowOpen={setShowPreviewPDF}
          selectedInvoice={selectedInvoice}
        />
      )}
       {showUploadModal && (
      <ModalComprobantePago
        show={showUploadModal}
        setShow={setShowUploadModal}
        selectedInvoice={selectedInvoice}
        onSuccess={window.location.reload}
      />)}
    </>
  );
};

export default CompanyView;
